var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "33",
      "height": "33",
      "viewBox": "0 0 33 33",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M24 16H3",
      "stroke": "#000",
      "stroke-width": "5",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M16.596 3.595L29 16 16.404 28.595",
      "stroke": "#000",
      "stroke-width": "5",
      "stroke-linecap": "square"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }